import React from "react";
import { Link } from "react-router-dom";
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram } from "react-icons/fa";

const QUICK_LINKS = [
  { label: "About", href: "#about" },
  { label: "Features", href: "#features" },
  { label: "Team", href: "#team" },
  { label: "Contact", href: "#contact" },
];

const PAGE_LINKS = [
  { label: "FAQs", to: "/faqs" },
  { label: "Support", to: "/support" },
];

const LEGAL_LINKS = ["Privacy Policy", "Terms of Service", "Accessibility"];

const SOCIAL_LINKS = [
  { icon: FaFacebook, label: "Facebook" },
  { icon: FaTwitter, label: "Twitter" },
  { icon: FaLinkedin, label: "LinkedIn" },
  { icon: FaInstagram, label: "Instagram" },
];

function scrollToSection(sectionId) {
  const element = document.getElementById(sectionId);
  if (element) {
    const navbarHeight = 80;
    const offsetPosition =
      element.getBoundingClientRect().top + window.pageYOffset - navbarHeight;
    window.scrollTo({ top: offsetPosition, behavior: "smooth" });
  }
}

export default function Footer() {
  return (
    <footer className="bg-[#053676] dark:bg-[#09062C]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          <div>
            <h3 className="text-white font-sans font-bold text-2xl mb-3">
              CHUSA
            </h3>
            <p className="text-white/70 font-sans text-sm leading-relaxed mb-4">
              Inspiring inclusive communities through modern, affordable, and
              reliable assistive technologies.
            </p>
            <p className="text-white/50 font-sans text-sm">
              From Uganda to the World
            </p>
          </div>

          <div>
            <h4 className="text-white font-sans font-bold text-sm uppercase tracking-wider mb-4">
              Quick Links
            </h4>
            <ul className="flex flex-col gap-2">
              {QUICK_LINKS.map((link) => (
                <li key={link.label}>
                  <button
                    onClick={() => scrollToSection(link.href.replace("#", ""))}
                    className="text-white/70 hover:text-white font-sans text-sm transition-colors"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
              {PAGE_LINKS.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-white/70 hover:text-white font-sans text-sm transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-sans font-bold text-sm uppercase tracking-wider mb-4">
              Legal
            </h4>
            <ul className="flex flex-col gap-2">
              {LEGAL_LINKS.map((label) => (
                <li key={label}>
                  <span className="text-white/70 font-sans text-sm cursor-default">
                    {label}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-sans font-bold text-sm uppercase tracking-wider mb-4">
              Follow Us
            </h4>
            <div className="flex gap-3">
              {SOCIAL_LINKS.map(({ icon: Icon, label }) => (
                <span
                  key={label}
                  className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/25 transition-colors cursor-pointer"
                  aria-label={label}
                >
                  <Icon className="text-white" size={18} />
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 mt-10 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-white/50 font-sans text-sm text-center sm:text-left">
            &copy; {new Date().getFullYear()} DMB Translation Services. All rights
            reserved.
          </p>
          <p className="text-white/40 font-sans text-sm">
            Made with purpose in Kampala, Uganda
          </p>
        </div>
      </div>
    </footer>
  );
}
